module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9658.7145a433.jpg";